import { type PropsWithChildren } from 'react'
import { Collapse } from '@mui/material'
import { Box } from '../../primitives/Box'
import { type ListItemTextProps } from './ListItemText'

type ListItemCollapseProps = PropsWithChildren & Pick<ListItemTextProps, 'isOpen' | 'more'>

export const ListItemCollapse = ({ children, isOpen, more }: ListItemCollapseProps) => (
  <Box
    sx={{
      width: '100%',
      lineHeight: 'normal',
    }}
  >
    {children}

    {more && (
      <Collapse in={isOpen} mountOnEnter>
        {more}
      </Collapse>
    )}
  </Box>
)
